// extracted by mini-css-extract-plugin
export var active = "_fv-7";
export var blink = "_fv-8";
export var dropDownSelector = "_fv-4";
export var dropDownWrapper = "_fv-3";
export var fakeCursor = "_fv-6";
export var fontSizeButton = "_fv-9";
export var formQuillEditor = "_fv-0";
export var pressed = "_fv-a";
export var qlBlank = "_fv-1";
export var textFormattingToolbar = "_fv-2";
export var textToolbarOption = "_fv-5";